<script setup lang="ts">
import BoNoticeDocVarField from './BoNoticeDocVarField.vue';
import BoLetterHead from './parts/BoLetterHead.vue';
import BoLetterClose from './parts/BoLetterClose.vue';
</script>

<template>
  <div class="bo-doc">
    <BoLetterHead recipient-mode="info_holder" />
    <p class="doc-p">
      <BoNoticeDocVarField field-key="company_name" />
      (Company Registration No. <BoNoticeDocVarField field-key="company_registration_no" />)
    </p>
    <p class="doc-p">
      Pursuant to subsection 60C(3) of the CA 2016, we know or have reasonable ground to believe that you know or has
      reasonable ground to believe that you know the identity of the beneficial owner of the Company and you are
      required to inform and confirm the beneficial ownership information within 30 days from the date of this notice.
    </p>
    <p class="doc-p">
      <b>2</b><br />
      Please proceed to Appendix B and include the following declaration as part of your reply:
    </p>
    <p class="doc-p" style="padding-left:16px; font-style:italic">
      “I/We hereby confirmed that the facts and information stated in this letter are true and to the best of my/our knowledge and belief.”
    </p>
    <p class="doc-p">
      <b>3</b><br />
      Please be informed that any person who fails to comply with this notice commits an offence under subsection
      60C(7) of the CA 2016 and/or provides false or misleading information commits an offence under section 593 of
      the CA 2016.
    </p>
    <BoLetterClose var-key="BO04" designation-key="signer_designation_BO04" />
  </div>
</template>

<style src="./boNoticeDoc.css"></style>
